import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms'
import { TypedFormGroup } from '@feature/forms/form-model';;

@Component({
    selector: 'wai-form-slider',
    templateUrl: './form-slider.component.html',
    styleUrls: ['./form-slider.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class FormSliderComponent {
  public asTypedFormGroup = (x: unknown): TypedFormGroup<any> => x as TypedFormGroup<any>;

  @Input() public minValue = -1;
  @Input() public maxValue = 3;
  @Input() public control: FormControl;

  public onSliderChange(value: number): void {
    if (value !== this.control.value) {
      this.control.patchValue(value);
      this.control.markAsDirty();
      this.control.markAsTouched();
    }
  }
}
